import initialState from '../initialState'
import { OPEN_MODAL, CLOSE_MODAL } from '../actions'

export function updateStateModal (
  state = initialState.updateStateModal,
  { type, data }
) {
  switch (type) {
    case OPEN_MODAL:
      return {
        ...state,
        open: true,
        data
      }

    case CLOSE_MODAL:
      return {
        ...state,
        open: false,
        data: null
      }
    default:
      return state
  }
}
